import styled from 'styled-components';

export const ConnectionListContainer = styled.div`
  padding: 0 ${({ theme: { token } }) => token.paddingXS}px;

  .connection-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${({ theme: { token } }) => token.paddingXXS}px;

    &:hover {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
      color: ${({ theme: { token } }) => token.colorPrimary};
      border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
    }
  }

  .label {
    color: ${({ theme: { token } }) => token.colorTextDescription};
  }

  .close-icon {
    color: ${({ theme: { token } }) => token.colorIcon};
    cursor: pointer;
  }
`;
